import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import FeeListComp from "../../components/FeeList";
import { getFeesList, getFeesCount, resetPaginatedData, getInvoiceProforma } from "./action";
import { getAllStudentForm } from '../OpenRegistration/action';
import { showModal, hideModal, pushModalToStack, popModalFromStack } from './../../actions/commonActions';

class StudentFeeList extends Component {
  constructor(props) {
    super(props);
    const linkProps = (this.props.location && this.props.location.state) || {};
    this.state = {
      templateType: linkProps.templateType,
      pageNumber: 1,
      pageSize: 25,
      activeTab: props.activeTab || 'fees',
      isFeesLoaded: false
    };
  }


  componentDidMount() {
    this.props.updateHeaderState({headerHeading: 'Fees'})
    const companyInfo = this.props.companyInfo || {};
    const customerInfo = this.props.customerInfo || {};
    const payload = {
      companyInfo,
      relationshipId: companyInfo.relationshipId,
      pageNumber: 1, pageSize: 25,
      customerId: customerInfo.customerId,
      formId: 0
    };
    this.props.getFeesList(payload);
    this.props.getFeesCount(payload);
    // this.props.getAllStudentForm(payload);
  }

  componentWillReceiveProps(props){
    if(!this.state.isFeesLoaded && props.allStudentList?.length){

      this.props.getInvoiceProforma({
        relationshipId: props.companyInfo?.relationshipId || 0,
        customerId: props.customerInfo?.customerId || 0,
        orgRegistrationId: props.allStudentList[0]?.orgRegistrationId
      });
      this.setState({isFeesLoaded: true});
    }
  }

  
  render() {
    return <FeeListComp  
              {...this.props}
              {...this.state}
              updateState={(data) => {
                this.setState(data);
              }} 
            />;
  }
}

const mapStateToProps = (state) => {
  return {
    companyInfo: state.common.companyInfo,
    relationshipId: state.common.companyInfo.relationshipId,
    customerInfo: state.common.customerInfo,
    feeList: state.school.feeList,
    feeCount: state.school.feeCount,
    invoiceProformaList: state.school.invoiceProformaList,
    allStudentList: state.dashboard.allStudentList
    // defaultSchoolForm: state.common.defaultSchoolForm,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showModal,
      hideModal,
      pushModalToStack,
      popModalFromStack,
      getFeesList,
      getFeesCount,
      resetPaginatedData,
      getAllStudentForm,
      getInvoiceProforma,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(StudentFeeList);
